module.exports = __webpack_public_path__ + "static/img/pay_fail.34d03b1f.svg";